import { SoortEnum } from '@/queries/mutaties/opdrachten';

export class ActiviteitVoorBewegingModel {
  constructor(
    public id: string,
    public soort: SoortEnum,
    public dienstregelpunt: string,
    public oorspronkelijkGeplandeTijd: string,
    public actueelGeplandeTijd: string,
    public uitvoeringsTijd: string,
    public afrijrichting: string,
    public volgnummer: number,
  ) {}
}

export function mapActiviteitVoorBeweging(rawModel: ActiviteitVoorBewegingModel): ActiviteitVoorBewegingModel {
  return new ActiviteitVoorBewegingModel(
    rawModel.id,
    rawModel.soort,
    rawModel.dienstregelpunt,
    rawModel.oorspronkelijkGeplandeTijd,
    rawModel.actueelGeplandeTijd,
    rawModel.uitvoeringsTijd,
    rawModel.afrijrichting,
    rawModel.volgnummer,
  );
}

export function mapArrayOfActiviteitVoorBeweging(
  rawArray: ActiviteitVoorBewegingModel[],
): ActiviteitVoorBewegingModel[] {
  return rawArray.map(mapActiviteitVoorBeweging);
}
